import React from 'react';
import "./CardHeading.css";

const CardHeading = ({name, issueNumber}) => {
  return <h4>{name + " #" + issueNumber}</h4>;
};

export default CardHeading;



// WEBPACK FOOTER //
// ./src/components/Atoms/text/CardHeading/CardHeading.js